module.exports =  
[
  {
    "name": "STUDENT",
    "label": "学生",
    "value": 0,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "EDIT",
        "label": "编辑",
        "value": 2
      }
    ]
  },
  {
    "name": "TEACHER",
    "label": "老师",
    "value": 1,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "EDIT",
        "label": "编辑",
        "value": 2
      }
    ]
  },
  {
    "name": "ROLE",
    "label": "角色",
    "value": 2,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "CREATE",
        "label": "创建",
        "value": 2
      },
      {
        "name": "UPDATE",
        "label": "修改",
        "value": 4
      },
      {
        "name": "DELETE",
        "label": "删除",
        "value": 8
      }
    ]
  },
  {
    "name": "DEPT",
    "label": "院系",
    "value": 3,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "EDIT",
        "label": "编辑",
        "value": 2
      }
    ]
  },
  {
    "name": "MAJOR",
    "label": "专业",
    "value": 4,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "CREATE",
        "label": "创建",
        "value": 2
      },
      {
        "name": "UPDATE",
        "label": "修改",
        "value": 4
      },
      {
        "name": "DELETE",
        "label": "删除",
        "value": 8
      }
    ]
  },
  {
    "name": "SCHOOL_TERM",
    "label": "学期",
    "value": 5,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "CREATE",
        "label": "创建",
        "value": 2
      },
      {
        "name": "UPDATE",
        "label": "修改",
        "value": 4
      },
      {
        "name": "DELETE",
        "label": "删除",
        "value": 8
      }
    ]
  },
  {
    "name": "COURSE",
    "label": "课程",
    "value": 6,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      }
    ]
  },
  {
    "name": "CLAZZ_COURSE",
    "label": "班课",
    "value": 7,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      }
    ]
  },
  {
    "name": "TEXTBOOK",
    "label": "教材",
    "value": 8,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "CREATE",
        "label": "创建",
        "value": 2
      },
      {
        "name": "UPDATE",
        "label": "修改",
        "value": 4
      },
      {
        "name": "DELETE",
        "label": "删除",
        "value": 8
      },
      {
        "name": "STAT",
        "label": "使用统计",
        "value": 16
      },
      {
        "name": "SUBMIT_REVIEW",
        "label": "提交审核",
        "value": 32
      },
      {
        "name": "WITHDRAW_REVIEW",
        "label": "撤回审核",
        "value": 64
      },
      {
        "name": "AUDIT",
        "label": "审核",
        "value": 128
      },
      {
        "name": "RELEASE",
        "label": "发布",
        "value": 256
      }
    ]
  },
  {
    "name": "REDEEM_CODE",
    "label": "兑换码",
    "value": 9,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "CREATE",
        "label": "创建",
        "value": 2
      },
      {
        "name": "DOWNLOAD",
        "label": "下载",
        "value": 4
      }
    ]
  },
  {
    "name": "COLUMN",
    "label": "栏目",
    "value": 10,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "CREATE",
        "label": "创建",
        "value": 2
      },
      {
        "name": "UPDATE",
        "label": "修改",
        "value": 4
      },
      {
        "name": "DELETE",
        "label": "删除",
        "value": 8
      }
    ]
  },
  {
    "name": "NEWS",
    "label": "新闻资讯",
    "value": 11,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "CREATE",
        "label": "创建",
        "value": 2
      },
      {
        "name": "UPDATE",
        "label": "修改",
        "value": 4
      },
      {
        "name": "DELETE",
        "label": "删除",
        "value": 8
      },
      {
        "name": "PUBLISH",
        "label": "发布/撤回",
        "value": 16
      }
    ]
  },
  {
    "name": "TEXTBOOK_CXJW_STAT",
    "label": "教材教务统计",
    "value": 12,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "DOWNLOAD",
        "label": "下载",
        "value": 2
      }
    ]
  },
  {
    "name": "ACCOUNT_MGT",
    "label": "账户管理",
    "value": 13,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "UPDATE",
        "label": "修改",
        "value": 4
      }
    ]
  },
  {
    "name": "DRILL",
    "label": "题库",
    "value": 14,
    "operations": [
      {
        "name": "RETRIEVE",
        "label": "查看",
        "value": 1
      },
      {
        "name": "CREATE",
        "label": "创建",
        "value": 2
      },
      {
        "name": "UPDATE",
        "label": "修改",
        "value": 4
      },
      {
        "name": "DELETE",
        "label": "删除",
        "value": 8
      }
    ]
  }
];